import { SITE_CONFIG } from '../siteConfig.js';
import { useGlobalStore } from '@digiwedge/global-state';
import { getAdminJwt, getAdminToken } from '../utils/pricingContext.js';

const normalizeBearer = (value: string): string => value.replace(/^Bearer\s+/i, '').trim();

export const buildAdminHeaders = (): HeadersInit => {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };
  const storeToken = useGlobalStore.getState?.()?.token;
  const jwt = storeToken || getAdminJwt();
  const token = getAdminToken();
  if (jwt) {
    headers['Authorization'] = `Bearer ${normalizeBearer(jwt)}`;
  } else if (token) {
    headers['x-admin-token'] = token;
  }
  return headers;
};

export const adminRequest = async <T>(path: string, options: RequestInit = {}): Promise<T> => {
  const response = await fetch(`${SITE_CONFIG.api.base}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      ...buildAdminHeaders(),
      ...(options.headers ?? {}),
    },
  });
  if (!response.ok) {
    const message = await response.text().catch(() => 'Request failed');
    throw new Error(message || `Request failed (${response.status})`);
  }
  if (response.status === 204) {
    return undefined as T;
  }
  const text = await response.text();
  if (!text) {
    return undefined as T;
  }
  return JSON.parse(text) as T;
};
